import isFullComposeShown from './isFullComposeShown';
import isInModule from 'owa-mail-store/lib/store/selectors/isInModule';
import isInMultiSelectMode from 'mini-mail-list-store/lib/utils/getIsInCheckedMode';
import isReadingPaneVisible from 'owa-mail-store/lib/store/selectors/isReadingPaneVisible';
import { isInSearchView } from 'mini-mail-list-store/lib/selectors/isInSearchView';
import { isUnifiedSearchView } from 'mini-mail-list-store/lib/selectors/isUnifiedSearchView';
import { Module } from 'mini-common-schema';

/**
 * Tells if any spoke screen is currently open in Mail module
 */
export default function isMailSpokeScreenOpen(): boolean {
    // Other screens like Feedback, Settings, Survey, Diagnostic panel etc don't come under Mail module
    // and are considered as Spoke screens.
    if (!isInModule(Module.Mail)) {
        return true;
    }

    return (
        isReadingPaneVisible() ||
        isFullComposeShown() ||
        isInSearchView() ||
        isUnifiedSearchView() ||
        isInMultiSelectMode()
    );
}
